import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiCompass } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../context/LocaleContext';
import ServiceIcon from './ServiceIcon';
import './ServiceSeoLandings.css';

const ServiceSeoLandings = ({ service }) => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const landings = (service.seoLandings || []).filter(
    (landing) => landing?.isActive !== false && landing?.slug && landing?.title
  );

  if (!landings.length) return null;

  return (
    <section className="service-seo-landings" aria-labelledby="service-seo-landings-title">
      <header className="service-seo-landings-heading">
        <span className="service-seo-landings-kicker">
          <FiCompass aria-hidden="true" />
          {t('serviceUi.landings.kicker')}
        </span>
        <h2 id="service-seo-landings-title">{service.seoLandingsTitle}</h2>
        {service.seoLandingsDescription && <p>{service.seoLandingsDescription}</p>}
      </header>

      <div className="service-seo-landings-grid">
        {landings.map((landing) => (
          <article className="service-seo-landing-card" key={landing.id || landing.slug}>
            <Link
              to={localePath(`/services/${service.slug}/${landing.slug}`)}
              aria-label={`${landing.title}: ${landing.subtitle || landing.description}`}
            >
              <span className="service-seo-landing-icon" aria-hidden="true">
                <ServiceIcon name={landing.icon} />
              </span>
              <span className="service-seo-landing-copy">
                <strong>{landing.title}</strong>
                {landing.subtitle && <small>{landing.subtitle}</small>}
              </span>
              <span className="service-seo-landing-action">
                {t('serviceUi.landings.view')}
                <FiArrowLeft aria-hidden="true" />
              </span>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ServiceSeoLandings;
